import React, { useRef } from 'react';
import { User, ChevronLeft, ChevronRight } from 'lucide-react';

const StudentProfile = ({ 
  students,
  activeStudent,
  studentImages,
  onStudentSelect,
  onImageUpload
}) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -100 : 100;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="flex flex-col">
      {/* Horizontal scroll for student thumbnails */}
      <div className="relative py-2 bg-gray-50">
        {students.length > 0 && (
          <button 
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full shadow p-1"
          >
            <ChevronLeft size={20} />
          </button>
        )}
        
        <div 
          ref={scrollRef}
          className="flex overflow-x-auto space-x-4 px-8 py-2 hide-scrollbar"
        >
          {students.map(student => (
            <button
              key={student}
              onClick={() => onStudentSelect(student)}
              className={`flex-shrink-0 flex flex-col items-center ${
                student === activeStudent ? 'scale-105' : ''
              }`}
            >
              <div className="w-10 h-10 relative">
                <img
                  src={studentImages[student] || "/api/placeholder/64/64"}
                  alt={student}
                  className={`rounded-full object-cover w-full h-full border-2 ${
                    student === activeStudent ? 'border-blue-500' : 'border-gray-200'
                  }`}
                />
              </div>
              <span className="text-xs mt-1">{student}</span>
            </button>
          ))}
        </div>

        {students.length > 0 && (
          <button 
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full shadow p-1"
          >
            <ChevronRight size={20} />
          </button>
        )}
      </div>

      {/* Active student profile */}
      {activeStudent && (
        <div className="flex flex-col items-center p-4">
          <div className="relative w-24 h-24 mb-2">
            <img
              src={studentImages[activeStudent] || "/api/placeholder/64/64"}
              alt={activeStudent}
              className="rounded-full object-cover w-full h-full border-4 border-blue-500"
            />
            <label className="absolute bottom-0 right-0 p-1 bg-white rounded-full shadow cursor-pointer">
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={(e) => onImageUpload(activeStudent, e.target.files[0])}
              />
              <User size={14} className="text-gray-500" />
            </label>
          </div>
          <h2 className="text-xl font-bold">{activeStudent}</h2>
        </div>
      )}
    </div>
  );
};

export default StudentProfile;